import { applySpec, concat, evolve, flatten, identity, ifElse, is, map, path, __ } from "ramda"
import { flow, untupled } from "fp-ts/es6/function"

import { NamespaceConfig } from "./config.js"
export { NamespaceConfig as config }

const toPath = flow(map(ifElse(is(Object), path(NamespaceConfig.domain.path), identity)), flatten)

export const domain = flow(
  untupled(applySpec({ path: toPath, selector: flow(toPath, path) })),

  // temporary hack to enable type conversion
  evolve({ path: identity, selector: identity }),
)

/**
 * Deprecated. Use `Namespace.domain`.
 */
export const includes = flow(concat(__, "."), concat)
